<div class="dashboard-container">
  <div class="dashboard-header">
    <h1>Hi, {{ usersName() }}</h1>
    <p>Welcome to Steelworks</p>
  </div>

  <p-card>

  <div class="dashboard-stat-filter flex justify-content-between py-3">
    <span [style]="{'font-family': 'sans-serif', 'font-size': '1rem', }" >{{ buildKitStatisticFilterItems[selectedBuildKitStatisticItem]?.hintText }}</span>
    <p-selectbutton (onChange)="onBuildKitStatisticFilterChange($event)" size="small" [allowEmpty]="false" [options]="buildKitStatisticFilterItems" [(ngModel)]="selectedBuildKitStatisticItem" optionLabel="name" optionValue="value" >
    </p-selectbutton>
  </div>

  <div class="widgets-grid">
    <p-card [dt]="themeCard">
      <div class="widget-content">
        <span [style]="{'color': 'var(--p-primary-color'}" class="text-3xl">${{ dashboardStatistics().estimatedMaterialCost | number: '1.0-0'}}</span>
        <span class="widgets-grid-item-secondary-text">Est Material Cost</span>
      </div>
    </p-card>
    <p-card [dt]="themeCard">
      <div class="widget-content">
        <span [style]="{'color': 'var(--p-primary-color'}" class="text-3xl">
          <bs-material-weight-icon [iconFill]="'var(--p-primary-color)'" [height]="20" [width]="20"></bs-material-weight-icon>
          {{ dashboardStatistics().estimatedRawMaterialWeight | number: '1.0-0' }}</span>
        <span class="widgets-grid-item-secondary-text">
        Est Material Weight (lbs)
        </span>
      </div>
    </p-card>
    <p-card [dt]="themeCard">
      <div class="widget-content">
        <span [style]="{'color': 'var(--p-primary-color'}" class="text-3xl">${{ dashboardStatistics().estimatedLaborCost | number: '1.0-0'}}</span>
        <span class="widgets-grid-item-secondary-text">
        Est Labor Cost
      </span>
      </div>
    </p-card>

    <p-card [dt]="themeCard">
    <div class="widget-content">
      <span [style]="{'color': 'var(--p-primary-color'}" class="text-3xl">
        <i class="pi pi-clock text-xl"></i> {{ dashboardStatistics().estimatedLaborTime | number: '1.0-0' }}
      </span>
      <span class="widgets-grid-item-secondary-text">
        Est Labor Time (hrs)
      </span>
    </div>
    </p-card>
<!--    <p-card [dt]="themeCard">-->
<!--    <div class="widget-content">-->
<!--      <span [style]="{'color': 'var(&#45;&#45;p-primary-color'}" class="text-3xl">${{ dashboardStatistics().estimatedTotalCost | number: '1.0-0' }}</span>-->
<!--      <span class="widgets-grid-item-secondary-text">-->
<!--       Est Total Cost-->
<!--      </span>-->

<!--    </div>-->
<!--    </p-card>-->
  </div>
  </p-card>

  <div class="pt-3">
    <p-card>
      <p>Your recent activity</p>

      @for(result of recentActivity(); track result){
        <div class="recent-activity-item">
          <div (click)="itemClicked(result)" class="flex flex-row">
            @switch (result.searchType){
              @case ('CadModels') {
                <bs-cad-icon [iconFill]="'var(--p-bs-globalsearch-iconcolor)'" [width]="27" [height]="27"></bs-cad-icon>
              }
              @case ('Projects') {
                <bs-project-icon [iconFill]="'var(--p-bs-globalsearch-iconcolor)'" [width]="27" [height]="27"></bs-project-icon>
              }
              @case ('BuildKits') {
                <bs-build-kit-icon [iconFill]="'var(--p-bs-globalsearch-iconcolor)'" [width]="27" [height]="27"></bs-build-kit-icon>
              }
              @case ('Drawings') {
                <bs-drawing-icon [iconFill]="'var(--p-bs-globalsearch-iconcolor)'" [width]="27" [height]="27"></bs-drawing-icon>
              }
            }
            <div [style]="{'padding-left': '15px'}" class="flex flex-wrap w-full justify-content-between row-gap-3">
              <span class="font-normal ">{{ result.name }}</span>
              <div>
                <span [style]="{'border-color': 'var(--p-content-border-color)', 'border-radius': 'var(--p-card-border-radius)'}" class="text-sm inline-flex flex-wrap py-2 px-3 font-medium border-1">
                  <i [style]="{'color': 'var(--p-primary-color)'}" class="pi pi-clock mr-2"></i>
                  <span [pTooltip]="result.mostRecentCreatedOnOrUpdatedOn" class="text-900"> {{ result.mostRecentCreatedOnOrUpdatedOn | timeFromNow }}</span>
                </span>
              </div>
            </div>
          </div>

          <div [style]="{'padding-left': '42px', 'font-family': 'sans-serif', 'color': '#b6b6b6', 'font-size': '.8rem', }" class="flex gap-2 ">
            @if(!result.descriptionOne && !result.descriptionTwo && !result.descriptionThree){
              <span>None</span>
            } @else {
              <span>{{ result.descriptionOne }}</span>
              @if(result.descriptionTwo && result.descriptionOne){
                &bull;
              }
              <span>{{ result.descriptionTwo }}</span>
              @if(result.descriptionThree && result.descriptionTwo){
                &bull;
              }
              <span>{{ result.descriptionThree }}</span>
            }
          </div>
        </div>
      }
    </p-card>
  </div>
</div>
